(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-klaviyo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('form#contact-us-page');

    if (!forms.length) {
      return;
    }

    forms.forEach(function (form) {
      var publicKey = form.dataset.klaviyoPublicKey || '';
      var listId = form.dataset.klaviyoListId || '';

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (!publicKey || !listId) {
          return;
        }
        ev.preventDefault();
        try {
          var mappedInputs = form.querySelectorAll('[data-klaviyo-attribute]');
          if (!mappedInputs.length) {
            return;
          }

          var profileAttributes = {};
          var properties = {};

          mappedInputs.forEach(function (input) {
            var attr = input.dataset.klaviyoAttribute;
            if (!attr) {
              return;
            }

            var value = '';

            if (input.type === 'checkbox') {
              if (!input.checked) {
                return;
              }
              value = input.value || 'true';
            } else if (input.type === 'radio') {
              if (!input.checked) {
                return;
              }
              value = input.value;
            } else {
              value = input.value;
            }

            if (!value) {
              return;
            }

            if (attr === 'email') {
              profileAttributes[attr] = value;
              return;
            }

            if (input.dataset.klaviyoCollect) {
              if (!Array.isArray(properties[attr])) {
                properties[attr] = [];
              }
              properties[attr] = properties[attr].concat(value);
            } else {
              properties[attr] = value;
            }
          });

          if (!profileAttributes.email) {
            return;
          }

          if (Object.keys(properties).length > 0) {
            profileAttributes.properties = properties;
          }

          var payload = {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Shopify Newsletter Form',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: profileAttributes,
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId,
                  },
                },
              },
            },
          };

          var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey);

          window
            .fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                revision: '2024-10-15',
              },
              body: JSON.stringify(payload),
              keepalive: true,
            })
            .then(function (response) {
              if (response.ok) {
                var successEl = form.querySelector('.form-success');
                if (successEl) {
                  successEl.style.display = '';
                }
                form.reset();
              }
            })
            .catch(function () {});
        } catch (e) {
          console.error('Klaviyo contact form error', e);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
